// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__fnta1","errorLogs":"EditorFooter_errorLogs__3CRYw"};